"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _withTranslation = require("../hoc/withTranslation");

var _styles = require("../styles");

/**
 * @type {function(*): *}
 */
var CardTitleSmall = (0, _withTranslation.withTranslation)(_styles.CardTitleSmallStyled);
var _default = CardTitleSmall;
exports.default = _default;